import { DealerRelatedUser } from '@api/types/dealer/Dealer';
import { TextCodes } from '@api/types/translation/TextCodes';
import { Button, DealerDetailsUserRow, Table, Title, useDealerDetailsContext } from '@components';
import { useAppDispatch } from '@hooks';
import { Box, styled } from '@mui/material';
import { setModalState } from '@store/modal/modal.slice';
import { t } from '@translations';
import { useMemo } from 'react';
import { getUserColumns } from './DealerDetails.config';

export const DealerDetailsUserTableWrapper = styled(Box)`
  margin-top: 40px;
`;

let counter = 0;

export const DealerDetailsUserList = () => {
  const { isAuth, canEditData, users, createModalId, isBerema } = useDealerDetailsContext();

  const dispatch = useAppDispatch();
  const openCreateModal = () => dispatch(setModalState({ id: createModalId, isVisible: true }));

  const generateKey = (associateNo?: string | null) => {
    counter++;
    return `${associateNo || 'user'}_${counter}`;
  };

  const visibleColumnNames = getUserColumns(canEditData, isBerema).map((column) =>
    column?.key?.toLowerCase()
  );

  const filteredColumns = useMemo(
    () =>
      getUserColumns(canEditData, isBerema)?.filter((column) =>
        visibleColumnNames?.includes(column.key.toLowerCase())
      ),
    [visibleColumnNames, canEditData, isBerema]
  );

  return (
    <DealerDetailsUserTableWrapper>
      {isAuth && (
        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between' }}>
          <Title variant='h4' noDot>
            {t(TextCodes.Dealer.Details.Users)}
          </Title>
          {canEditData && (
            <Button variant='ghost' onClick={openCreateModal}>
              {t(TextCodes.Dealer.Details.CreateUser)}
            </Button>
          )}
        </Box>
      )}
      {isAuth && (
        <Table
          headerColumns={filteredColumns}
          itemsOnPage={users?.length}
          list={users as DealerRelatedUser[]}
          renderRow={(user) => (
            <DealerDetailsUserRow
              key={generateKey(user.associatedNo)}
              user={user}
              visibleColumnNames={visibleColumnNames}
              filteredColumns={filteredColumns}
            />
          )}
        />
      )}
    </DealerDetailsUserTableWrapper>
  );
};
